import { isEmpty } from 'lodash';

import { MedicineDetails } from '@dreryk/drerykweb-medicine-api';

import { Accordion } from '@dreryk/react-components';

import { ORDERED_MEDICINE_DETAILS_ACCORDION_SECTIONS } from '~libs.shared.medicine';

import { translationKeys } from '../../../translations';

import { MedicineDetailsContent } from './MedicineDetailsContent';
import { StyledMedicineDetailsAccordion } from './MedicineDetailsAccordion.styled';

type MedicineDetailsAccordionProps = {
   readonly medicineDetails: MedicineDetails;
};

export const MedicineDetailsAccordion = (props: MedicineDetailsAccordionProps): JSX.Element => {
   return (
      <StyledMedicineDetailsAccordion>
         <Accordion testId={'medicineDetails'}>
            {ORDERED_MEDICINE_DETAILS_ACCORDION_SECTIONS.map((sectionKey) => (
               <Accordion.Section
                  key={sectionKey}
                  id={sectionKey}
                  label={translationKeys.medicine.details.section[sectionKey]}
                  disabled={isEmpty(props.medicineDetails[sectionKey])}
                  testId={sectionKey}
               >
                  <MedicineDetailsContent sectionKey={sectionKey} medicineDetails={props.medicineDetails} />
               </Accordion.Section>
            ))}
         </Accordion>
      </StyledMedicineDetailsAccordion>
   );
};
